import React, {FC, ReactNode, useState} from 'react'
import {UiTheme, UiThemeSize} from "@view/theme/types";
import {IThemeContext} from "@view/theme/context/types";
import {ThemeProvider} from "@mui/material/styles";
import {useInitialTheme} from "@view/theme/hooks/useTheme";
import {useGetThemeStyles} from "@view/theme/context/hooks/useGetThemeStyles";
import {getInitialThemeSize} from "@view/theme/helpers";

export const ThemeContext = React.createContext<IThemeContext | null>(null)

interface IProps {
    children: ReactNode,
    forcedTheme?: UiTheme,
    forcedThemeSize?: UiThemeSize,

}

const ThemeContextProvider: FC<IProps> = ({
                                              children,
                                              forcedTheme,
                                              forcedThemeSize,
                                          }) => {
    const [theme, setTheme] = useState<UiTheme>('light')
    const [themeSize, setThemeSize] = useState<UiThemeSize>(getInitialThemeSize)

    useInitialTheme(setTheme, forcedTheme)

    const themeStyles = useGetThemeStyles({
        theme,
        forcedTheme,
        themeSize,
        forcedThemeSize,
    })

    return (
        <ThemeProvider
            theme={themeStyles}
        >
            <ThemeContext.Provider
                value={{
                    theme: forcedTheme ?? theme,
                    setTheme,
                    themeSize:forcedThemeSize ?? themeSize,
                    setThemeSize,
            }}
            >
                {children}
            </ThemeContext.Provider>
        </ThemeProvider>
    );
};

export default ThemeContextProvider;
